import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { CustomerService } from '../../../services/customer.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-document-approval-preview',
  templateUrl: './document-approval-preview.component.html',
  styleUrls: ['./document-approval-preview.component.scss']
})
export class DocumentApprovalPreviewComponent implements OnInit {
  document: string;
  isLoading: boolean = true;
  confirmLoading: boolean = false;
  action: string;
  errorMsg: string = '';
  modal: any;
  customerForm: FormGroup;
  showSubmissionComplete: boolean = false;
  language = localStorage.getItem('lang') || 'en';
  haveTaxData: boolean;

  pdf: any;
  pdfPage = 1;
  pdfPageLength: number;
  pdfError: string;
  pdfLoaded = false;

  @ViewChild('approveModal') approveModal: TemplateRef<any>;
  @ViewChild('rejectModal') rejectModal: TemplateRef<any>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private customerApiService: CustomerService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.document = params.code;
      if (this.document) {
        this.getTaxData();
      }
    });
  }

  closeModal() {
    if (this.modal) {
      this.modal.close();
    }
    this.confirmLoading = false;
  }

  getErrorMessage(error: any) {
    this.errorMsg = '';
    this.errorMsg = error.error.detail ? error.error.detail : 'There was an error while loading data. Please contact the administrator';
    this.closeModal();
  }

  submissionCompleted() {
    this.confirmLoading = false;
    this.showSubmissionComplete = true;
    this.closeModal();
  }

  back() {
    this.errorMsg = '';
  }

  changeLanguage(lang: string) {
    if (lang === 'en') {
      this.translate.use('en');
      localStorage.setItem('lang', 'en');
    } else if (lang === 'th') {
      this.translate.use('th');
      localStorage.setItem('lang', 'th');
    }
  }

  confirm() {
    this.confirmLoading = true;
    if (this.action === 'approve') {
      this.customerApiService.approveTaxData(this.document).subscribe(
        (result: any) => {
          this.submissionCompleted();
        },
        (error) => {
          this.confirmLoading = false;
          this.getErrorMessage(error);
        }
      );
    }

    else if (this.action === 'reject') {
      let data = this.customerForm.getRawValue()
      this.customerApiService.rejectTaxData(this.document, {
        contact: data.contact,
        remark: data.remark,
        suggestion: {
          address: data.address,
          branch_code: data.branchCode,
          email: data.email,
          cc_email: data.ccEmail,
          country_code: data.countryCode,
          name: data.name,
          post_code: data.postCode,
          tax_id: data.tax_id,
        }
      }).subscribe(
        (result: any) => {
          this.submissionCompleted();
        },
        (error) => {
          this.confirmLoading = false;
          this.getErrorMessage(error);
        }
      );
    }
    return
  }

  rejectTaxData() {
    this.action = 'reject';
    this.modal = this.modalService.open(
      this.rejectModal,
      {
        backdrop: 'static',
        size: 'lg'
      }
    );
  }

  approveTaxData() {
    this.action = 'approve';
    this.modal = this.modalService.open(
      this.approveModal,
      {
        backdrop: 'static',
        centered: true
      }
    );
  }

  getTaxData() {
    this.isLoading = true;
    this.customerApiService.getTaxData(this.document).subscribe(
      (result: any) => {
        this.haveTaxData = true
        this.isLoading = false;
        this.pdf = {
          url: result.pdf_file,
          withCredentials: false,
        }
        this.customerForm = this.formBuilder.group({
          address: [result.address],
          branchCode: [result.branch_code],
          branchName: [result.branch_name],
          ccEmail: [result.cc_email],
          countryCode: [result.country_code],
          email: [result.email],
          name: [result.name],
          postCode: [result.post_code],
          taxID: [result.tax_id],
          remark: [null],
          contact: [null]
        })
      },
      (error) => {
        this.isLoading = false;
        this.haveTaxData = false
        this.getErrorMessage(error);
      }
    )
  }

  setPDF(pdf: PDFDocumentProxy) {
    this.pdfPageLength = pdf.numPages;
    this.pdfLoaded = true;
  }

  resetPDF() {
    this.pdfLoaded = false;
    this.pdfPage = 1;
    this.pdfError = undefined;
  }

  nextPage() {
    if (this.pdfPage < this.pdfPageLength) {
      this.pdfPage++;
    }
  }

  prevPage() {
    if (this.pdfPage > 1) {
      this.pdfPage--;
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-approval/document-approval-preview/document-approval-preview.component.ts